module.exports = __webpack_public_path__ + "static/media/honeywell.6fca8571.jfif";